import React, { useEffect, useState } from "react";
import { Modal, Button, Header, Icon } from "semantic-ui-react";
import "./WarningModal.css";
import WithEventWarning from "../WithEventWarning/WithEventWarning";
import SharedFunctions from "../../utils/SharedFunctions";
import TimerDisplay from "../TimerDisplay/TimerDisplay";
import OperatorEndpoints from "../../lib/operator/OperatorEndpoints";
import WorkstationEndpoints from "../../lib/workstation/WorkstationEndpoints";

import { getParamValue } from "../../utils/UtilMethods";
import { WARNING_MODAL } from "../../utils/constants/componentConstants";

const WarningModal = ({
  open,
  onClose,
  message,
  header,
  cssClass,
  className,
  autoClose,
  isCartInstruction,
  workstationID,
  cartSuggestion,
  changeCartSuggestion,
  acceptCart,
  closeButtonText,
  errorCode,
  cancelButtonText,
}) => {
  if (className === "") {
    className = cssClass;
  }

  let showTimer = false;

  if (header === "Hänvisning.") {
    showTimer = true;
  }
  const [, setDesiredCartID] = useState(-1);

  const handleOnClose = (choice = null) => {
    if (isCartInstruction && cartSuggestion !== -1) {
      acceptCart(cartSuggestion, true, true);
    }
    if (choice !== null) {
      onClose(choice);
    } else {
      onClose(cartSuggestion);
    }
  };

  useEffect(() => {
    function onOpen() {
      SharedFunctions.LogPopupShownEvent(`${WARNING_MODAL} pga: ${header} - ${message}`);
    }
    if (open) {
      onOpen();
    }
  }, [open, header, message]);

  useEffect(() => {
    function close() {
      handleOnClose();
    }
    if (autoClose) {
      let interval = setInterval(async () => {
        //This function should be a prop
        let ws = getParamValue("ws");
        let result = await WorkstationEndpoints.isPackingAllowedInWorkstation(ws);
        if (result) close();
      }, 5000);
      return () => clearInterval(interval);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [autoClose]);

  useEffect(() => {
    function close() {
      handleOnClose();
    }
    if (isCartInstruction) {
      let interval = setInterval(async () => {
        //This function should be a prop
        let instruction = await OperatorEndpoints.getWorkstationInstruction(workstationID);
        setDesiredCartID(instruction.desiredCartId);
        if (instruction.desiredCartId !== cartSuggestion && instruction.desiredCartId !== -1) {
          changeCartSuggestion(instruction);
        } else if (instruction.desiredCartId === -1) {
          close();
        }
      }, 5000);
      return () => clearInterval(interval);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCartInstruction]);

  return (
    <Modal
      open={open}
      onClose={() => handleOnClose()}
      size="small"
      className={className}
      closeOnEscape={false}
      closeOnDimmerClick={false}
    >
      <Header>
        <div className="warningHeaderContainer">
          <p className="warningHeader">
            <Icon size="big" name="warning sign" color="red"></Icon>
            {header}
          </p>
          {showTimer ? (
            <TimerDisplay type={2} timer="operationinstructiontimer" trigger={open}></TimerDisplay>
          ) : null}
        </div>
      </Header>
      <Modal.Content>
        <h1 dangerouslySetInnerHTML={{ __html: message }} />
        {errorCode && <h5>(ID: {errorCode})</h5>}
      </Modal.Content>
        <Modal.Actions>
        {(!autoClose || closeButtonText) && (
          <Button primary onClick={() => handleOnClose(cancelButtonText ? true : null)}>
            {closeButtonText ? closeButtonText : `OKEJ`}
          </Button>
        )}
         {(cancelButtonText) && (
          <Button color="red" onClick={() => handleOnClose(false)}>
            {cancelButtonText ? cancelButtonText : `AVBRYT`}
          </Button>
        )}
        </Modal.Actions>
    </Modal>
  );
};

export default WithEventWarning(WarningModal);
